export default __webpack_public_path__ + "media/images/users/user-cristal-smith-270x298-713ea577a7b240a527bb149a7ae402d6.jpg";